import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { ReactComponent as ArrowVertical } from '@pflegia/ui/icons/arrow-vertical.svg';

export interface HeadlineProps {
  title: React.ReactElement;
  subTitle?: React.ReactElement;
  titleClassName?: string;
  subTitleClassName?: string;
  Component?: keyof React.JSX.IntrinsicElements;
  showArrow?: boolean;
  arrowPosition?: 'left' | 'right';
}

const Headline = ({
  titleClassName,
  subTitleClassName,
  title,
  subTitle,
  Component = 'h2',
  showArrow = false,
  arrowPosition = 'left',
}: HeadlineProps) => {
  const arrow = (
    <ArrowVertical
      className={clsx('text-primary h-20 w-7 shrink-0 overflow-visible', {
        '-scale-x-100': arrowPosition === 'right',
      })}
    />
  );

  return (
    <>
      <div className={clsx('flex items-center justify-center gap-2', { 'mb-6': !subTitle })}>
        {showArrow && !subTitle && arrowPosition === 'left' && arrow}
        <Component className={twMerge(clsx('mb-6 text-center text-2xl md:text-4xl', { 'md:mb-16': !subTitle }, titleClassName))}>
          {title}
        </Component>
        {showArrow && !subTitle && arrowPosition === 'right' && arrow}
      </div>
      {subTitle && (
        <div className={twMerge(clsx('flex items-center gap-2', { 'mb-16 md:mb-24': !showArrow }, subTitleClassName))}>
          {showArrow && arrowPosition === 'left' && arrow}
          <p className={clsx('grow text-center', showArrow && 'mb-14')}>{subTitle}</p>
          {showArrow && arrowPosition === 'right' && arrow}
        </div>
      )}
    </>
  );
};

export default Headline;
